import normalize from "json-api-normalizer"
import customAxios from "./customAxios"

function productPayload(product) {
    return {
        name: product.name,
        code: product.code,
        description: product.description,
        scope_of_work: product.scopeOfWork,
        workflow: product.workflow,
        starting_division: product.startingDivision,
        estimated_hours: product.estimatedHours,
        client_due_date_count: product.clientDueDateCount,
        drafting_due_date_count: product.draftingDueDateCount,
        field_work_upload_days_count: product.fieldWorkUploadDaysCount,
        default_file_release: product.defaultFileRelease,
        operations_can_book_rebook: product.operationsCanBookRebook,
        active_flag: product.activeFlag,
        selectable: product.selectable,
        dbyd_required: product.dbydRequired
    }
}

export const getProduct = baseUrl => {
    const path = `${baseUrl}/products/get-products`
    return customAxios.get(path)
        .then(({ data, status }) => ({ response: normalize(data), status }))
        .catch(error => ({ error }))
}

export const getFilteredProducts = (baseUrl, jobType) => {
    const path = `${baseUrl}/products/${jobType}/products`
    return customAxios.get(path)
        .then(({ data, status }) => ({ response: normalize(data), status }))
        .catch(error => ({ error }))
}

export const getAdminProducts = (baseUrl, params) => {
    const path = `${baseUrl}/products/admin`
    return customAxios.get(path, { params })
        .then(({ data, status }) => ({ response: normalize(data), meta: data.meta || {}, status }))
        .catch(error => ({ error }))
}

export const getAdminProduct = (baseUrl, id) => {
    const path = `${baseUrl}/products/admin/${id}`
    return customAxios.get(path)
        .then(({ data, status }) => ({ response: normalize(data), status }))
        .catch(error => ({ error }))
}

export const createAdminProduct = (baseUrl, product) => {
    const path = `${baseUrl}/products/admin`
    return customAxios.post(path, { product: productPayload(product) })
        .then(({ data, status }) => ({ response: normalize(data), status }))
        .catch(error => ({ error }))
}

export const updateAdminProduct = (baseUrl, id, product) => {
    const path = `${baseUrl}/products/admin/${id}`
    return customAxios.put(path, { product: productPayload(product) })
        .then(({ data, status }) => ({ response: normalize(data), status }))
        .catch(error => ({ error }))
}

export const archiveAdminProduct = (baseUrl, id, archive) => {
    const path = `${baseUrl}/products/admin/${id}/archive`
    return customAxios.put(path, { archive })
        .then(({ data, status }) => ({ response: normalize(data), status }))
        .catch(error => ({ error }))
}
